import styled, { css } from "styled-components";

import { colors } from "components";

interface IProps {
  widthHeight?: number;
  isFilter: boolean;
}

export const Container = styled.button<IProps>`
  width: ${(props) => (props.widthHeight ? props.widthHeight + "px" : "40px")};
  height: ${(props) => (props.widthHeight ? props.widthHeight + "px" : "40px")};
  background-color: ${(props) =>
    props.isFilter ? "rgb(233, 141, 11)" : colors.default_blue};
  border-radius: 50%;
  border: 2px
    ${(props) => (props.isFilter ? "rgb(233, 141, 11)" : colors.default_blue)}
    solid;
  cursor: pointer;

  ${(props) =>
    props.disabled
      ? css`
          border-color: #7887a9;
          cursor: default;
          background-color: ${colors.default_base_black_menu_1};
        `
      : css`
          &:hover {
            border-color: ${colors.default_base_white};
            background-color: ${colors.default_dark_blue};
            background: ${colors.default_dark_blue};
          }
        `}
`;

export const PlusIcon = styled.span<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.default_base_white};
  font-size: 20px;

  ${(props) =>
    props.disabled &&
    css`
      border-color: #7887a9;
      cursor: default;
      opacity: 0.5;
    `}
`;
